import SkeletonData = PIXI.spine.core.SkeletonData;
import {gsap, TimelineLite} from "gsap";
import {RKHelper} from "../utils/RKHelper";
import {HEART_STATE} from "./enums/RoadKillEnums";
import {RoadKill} from "../RoadKill";
import {RoadKillSound} from "../sound/RoadKillSound";

export class Life extends PIXI.spine.Spine {
    private _id: number;
    private _state: HEART_STATE;

    constructor(id: number, spineData: SkeletonData = RoadKill.assetLoader.getSpineAsset("heart")) {
        super(spineData);
        this._id = id;
        this.init();
    }

    private _isGolden: boolean = false;

    get isGolden(): boolean {
        return this._isGolden;
    }

    set isGolden(value: boolean) {
        if (value != this._isGolden) {
            this._isGolden = value;
            if (RoadKill.model.isRestore) {
                this.setState(this._isGolden ? HEART_STATE.GOLDEN : HEART_STATE.GOLDEN_OUT);
            } else {
                this.setState(this._isGolden ? HEART_STATE.GOLDEN : HEART_STATE.GOLDEN_OUT)
            }
        }
    }

    public setState(state: HEART_STATE): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (state !== this._state) {
            this._state = state;
            if (state === HEART_STATE.IN) {
                tl.add(gsap.to(this, {duration: 0.01, alpha: 1}));
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.HEART_ADD);
                });
                tl.add(RKHelper.playSpineWithTimeline(this, 0, "heartIn"));
            } else if (state === HEART_STATE.OUT) {
                tl.add(RKHelper.playSpineWithTimeline(this, 0, "heartOut"));
                tl.add(gsap.to(this, {duration: 0.1, alpha: 0}));
            } else if (state === HEART_STATE.GOLDEN) {
                this._isGolden = true;
                if (this.alpha === 0) {
                    tl.add(gsap.to(this, {duration: 0.01, alpha: 1}));
                }
                tl.add(() => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.HEART_ADD);
                });
                tl.add(RKHelper.playSpineWithTimeline(this, 0, "heart2In"));

            } else if (state === HEART_STATE.GOLDEN_OUT) {
                this._isGolden = false;
                tl.add([RKHelper.playSpineWithTimeline(this, 0, "hear2tOut"), () => {
                    RoadKill.soundPlayer.playTrack(RoadKillSound.HEART_GOLDEN_TO_RED);
                }]);
            }
        }
        return tl;
    }

    public shiftRightOnUpgrade(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._id++;
        tl.to(this, {duration: 0.2, x: this.getPosXById(this._id)});
        // tl.add(() => {
        //     this._id++;
        // });
        return tl;
    }

    private getPosXById(id: number): number {
        let x: number = 0;
        if (id === 2) {
            x = 112;
        } else if (id === 1) {
            x = 70;
        } else if (id === 0) {
            x = 28;
        }
        return x;
    }

    private init(): void {
        this.name = "Life_" + this._id;
        this.position.set(this.getPosXById(this._id), 58);
        this.alpha = 0;
    }

}